import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default {
  defaultSet: 'mdi',
  aliases,
  sets: {
    mdi,
  },
}
